import React from "react";
import { TableUi } from "../../../../ui/TableUi";
import { ButtonUi } from "../../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../../types/typesConstants";
import { Space } from "antd";
import { useDispatch } from "react-redux";
import { showDeleteConfirm } from "./../../../../../helpers/confirmModal";
import {
  tareaProduccionSetActive,
  tareaProduccionStartDelete,
} from "../../../../../actions/produccion";

const columns = (acciones) => {
  const { handleEditar, handleEliminar } = acciones;
  return [
    {
      title: "#",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
    },

    {
      title: "",
      dataIndex: "opciones",
      key: "opciones",
      render: (text, record) => (
        <Space wrap>
          <ButtonUi
            key="Editar"
            typeUi={TipoButtonConstants.EditarTable}
            onClick={() => handleEditar(record)}
          />
          <ButtonUi
            key="Eliminar"
            typeUi={TipoButtonConstants.EliminarTable}
            onClick={() => handleEliminar(record)}
          />
        </Space>
      ),
    },
  ];
};
export const TareaProduccionTable = ({ data, onOpenModal }) => {
  const dispatch = useDispatch();
  const handleEditar = (record) => {
    dispatch(tareaProduccionSetActive(record));
    onOpenModal();
  };
  const handleEliminar = (record) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la tarea de programación?",
      record.nombre,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(tareaProduccionStartDelete(record));
        }
      }
    );
  };
  return (
    <TableUi
      data={data}
      columns={columns({ handleEditar, handleEliminar })}
      rowKey="id"
      size="small"
    />
  );
};
